<template>
  <div class="export-csv" :class="{ 'export-csv--locked': isDisabled }">
    <span v-if="isDisabled" class="export-csv__tooltip" role="tooltip">
      {{ activeTooltipText }}
    </span>
    <Button
      variant="outlined"
      color="alternative"
      size="sm"
      :disabled="isDisabled"
      :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
      @click="$emit('click')"
    >
      <template #iconBefore>
        <i class="fa-solid fa-file-csv"></i>
      </template>
      {{ isExporting ? 'Exporting...' : 'Export .CSV' }}
      <span v-if="countdown > 0">({{ countdownText }})</span>
    </Button>
  </div>
</template>

<script>
import Button from '@/components/ui/Button';

export default {
  name: 'ExportCsvButton',
  components: {
    Button,
  },
  props: {
    isExporting: {
      type: Boolean,
      default: false,
    },
    countdown: {
      type: Number,
      default: 0,
    },
    countdownText: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: 'Please wait a moment before downloading again.',
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyTooltipText: {
      type: String,
      default: 'No data to export.',
    },
  },
  computed: {
    isDisabled() {
      return this.isEmpty || this.isExporting || this.countdown > 0;
    },
    activeTooltipText() {
      return this.isEmpty ? this.emptyTooltipText : this.tooltipText;
    },
  },
};
</script>

<style scoped>
.export-csv {
  position: relative;
  display: inline-flex;
}

.export-csv__tooltip {
  position: absolute;
  top: 50%;
  right: calc(100% + 12px);
  z-index: 20;
  width: max-content;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
  background: #1f2937;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-50%);
  transition: opacity 0.15s ease-in-out;
}

.export-csv__tooltip::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #1f2937;
}

.export-csv--locked:hover .export-csv__tooltip {
  opacity: 1;
  visibility: visible;
}
</style>
